var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccordionArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#7F7F7F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.278 12.238l4.314-4.326c.778-.78.778-2.044 0-2.824L2.278.762C1.86.342 1.181.342.762.76L.759.762c-.42.42-.42 1.102 0 1.523L4.962 6.5.759 10.715c-.42.42-.42 1.102 0 1.523.419.42 1.098.42 1.517.002l.002-.002z",
    transform: "translate(-311 -1135) translate(60 710) rotate(90 -80.5 345)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionArrow);
export default __webpack_public_path__ + "static/media/accordion-arrow.7aa90dbebbb741ae83274abd910b317f.svg";
export { ForwardRef as ReactComponent };